import React from 'react';

import { formatDate, formatTime } from 'utils';

import { VerticalLayout } from './Layout';
import { Text, TextLink } from './Text';

export const DateTimeDisplay = ({ dateString, to }: { dateString?: string; to?: string }) =>
    dateString ? (
        <VerticalLayout>
            {to ? <TextLink to={to}>{formatDate(dateString)}</TextLink> : <Text>{formatDate(dateString)}</Text>}
            <Text helper $themeColor="subtle">
                {formatTime(dateString)}
            </Text>
        </VerticalLayout>
    ) : null;
